window.SurveyQuestion = Block.extend({

    render: function() {
        var content = this.getContent(this.data);
        this.$el.html(content);

        this.$content = this.$el.find(".content-holder");

        this.textArea = new TextArea({
            id: "other",
            rows: 4,
            maxLength: this.data.maxOtherLength,
            useCharCounter: true,
            required: true,
            disabled: true
        });
        this.$content.append(this.textArea.$el);

        this.setupButtons();

        OverviewAnimation.animateIn(this.$el.find(".overview"));
    },

    setupButtons: function() {
        this.options = new ListBox({
            el: this.$el.find(".list-group"),
            isSingleSelect: false
        });
        this.listenTo(this.options, "onOptionToggled", this.handleOptionToggled);

        this.saveButton = new Button({
            el: this.$el.find(".save-button"),
            isDisabled: true
        });
        this.listenTo(this.saveButton, "onClick", this.handleSaveClicked);

        var cancelButton = new Button({
            el: this.$el.find(".cancel-button")
        });
        this.listenTo(cancelButton, "onClick", this.handleCancelClicked);
    },

    handleCancelClicked: function() {
        this.app.router.next();
    },

    handleSaveClicked: function() {
        var $selected = this.options.getSelected();
        var isOtherValid = this.textArea.isValid() || this.textArea.isDisabled();
        if($selected.length > 0 && isOtherValid) {
            this.complete();
            this.trigger("onQuestionAnswered", {
                target: this,
                selected: _.where(this.data.options, {isSelected: true}),
                other: this.textArea.getValue()
            });
            this.app.router.next();
        } else {
            this.textArea.$el.addClass("submitted");
        }
    },

    handleOptionToggled: function(index, isSelected, $option, listBox) {
        var $selected = this.options.getSelected();
        this.saveButton.toggleDisabled($selected.length == 0);

        this.data.options[index].isSelected = isSelected;

        var otherIndex = listBox.options.length - 1;
        if(index === otherIndex) {
            this.textArea.toggleDisabled(!isSelected);
        }

        this.textArea.$el.removeClass("submitted");
    },

    getContent: function(data) {
        return Handlebars.templates["survey/surveyquestion"](data);
    },

    getData: function($xml, language) {
        var data = {};
        data.id = $xml.find("mainText").attr("id").trim();
        data.title = $xml.find("mainText").find("en").find("text").text().trim();
        data.question = $xml.find("question").find("en").find("text").text();
        data.statement = $xml.find("statement").find("en").find("text").text();

        data.options = [];
        var $options = $xml.find("options").find("index");
        _.each($options, function(option, i) {
            var $option = $(option);
            var item = {
                id: i,
                title: $option.find("en").find("label").text(),
                isSelected: false
            };

            data.options.push(item);
        }, this);

        data.otherLabel = LanguageManager.getString("other_label");
        data.saveLabel = LanguageManager.getString("save");
        data.cancelLabel = LanguageManager.getString("cancel");

        data.maxOtherLength = SurveyQuestion.MAX_OTHER_LENGTH;

        return data;
    },

    destroy: function() {
        this.textArea.destroy();

        Block.prototype.destroy.call(this);
    }
}, {
    MAX_OTHER_LENGTH: 100
});
